import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CastSpettacolo } from '../../../../shared/interface';
import { Table } from 'primeng/table';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';

@Component({
  selector: 'app-cast-spettacolo-backoffice',
  templateUrl: './cast-spettacolo-backoffice.component.html',
  styleUrl: './cast-spettacolo-backoffice.component.css'
})
export class CastSpettacoloBackofficeComponent implements OnInit{
  
  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild(ConfirmPopup) delete!: ConfirmPopup;

  @Input() casts: CastSpettacolo[] = [];
  @Output() data = new EventEmitter<CastSpettacolo[]>();
  
  cast?: CastSpettacolo;

  ruoli: { ruolo: string }[] = [
    { ruolo: 'Autore' },
    { ruolo: 'Attori' },
    { ruolo: 'Coreografie' },
    { ruolo: 'Costumi' },
    { ruolo: 'Luci' },
    { ruolo: 'Musiche' },
    { ruolo: 'Regia' },
    { ruolo: 'Produzione' }
  ];
  ruoli_filtrati: { ruolo: string }[] = [...this.ruoli];

  add: boolean = false;
  edit: boolean = false;

  formCast!: FormGroup;  

  ngOnInit(): void {

    this.formCast = new FormGroup({
      ruolo: new FormControl(null, Validators.required),
      cast: new FormControl(null),
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onFilterRuoli(event: AutoCompleteCompleteEvent) {  
    this.ruoli_filtrati = this.ruoli.filter(ruolo => ruolo.ruolo.toLowerCase().indexOf(event.query.toLowerCase()) == 0);     
  }

  onOpenAdd() {
    this.add = true;
    this.formCast.reset();
    this.formCast.markAsPristine();
    this.formCast.markAsUntouched();
  }

  onAdd(reset: boolean) {

    let cast: any = {
      ruolo: this.formCast.get('ruolo')?.value ? (this.formCast.get('ruolo')?.value.ruolo ? this.formCast.get('ruolo')?.value.ruolo : this.formCast.get('ruolo')?.value) : '',
      cast: this.formCast.get('cast')?.value || '',
    }

    this.casts.push(cast);
    this.data.emit(this.casts);

    if (reset) {
      this.formCast.reset();
      this.formCast.markAsPristine()
      this.formCast.markAsUntouched();
    } else {
      this.add = false;
    }

  }

  onOpenEdit(cast: CastSpettacolo) {
    this.cast = cast;
    this.formCast.setValue({
      ruolo: cast.ruolo,
      cast: cast.cast,
    })
    this.edit = true;
  }

  onEdit() {

    this.casts.filter(cast => cast.id === this.cast?.id).map(cast => {
      cast.ruolo = this.formCast.get('ruolo')?.value ? (this.formCast.get('ruolo')?.value.ruolo ? this.formCast.get('ruolo')?.value.ruolo : this.formCast.get('ruolo')?.value) : '';
      cast.cast = this.formCast.get('cast')?.value || '';
    });
    this.data.emit(this.casts);

    this.edit = false;

  }

  onOpenDeleteCast(event: Event, cast: CastSpettacolo, index: number) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare il cast dallo spettacolo?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteCastSpettacolo(cast.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.casts.splice(index, 1)
            this.apiService.message("success", "Eliminazione", "Il cast è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDeleteCast() {
    this.delete.accept();
  }

  onAnnullaDeleteCast() {
    this.delete.reject();
  }

  onCloseModal() {    
    this.add = false;
    this.edit = false;
  }
}
